import { AnalyticsPaymentStatusUpdateService } from './utils';
import { IThunkActionCreator } from '../../store';

export const unsubscribePaymentStatusUpdate = (): IThunkActionCreator => () => {
  AnalyticsPaymentStatusUpdateService.cancel();
};
